var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2312,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F0F3F9",
    stroke: "#8194D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.161 16.182C10.848 16.182 9.769 15.74 8.924 14.856C8.079 13.972 7.65 12.854 7.65 11.489C7.65 10.124 8.079 9.006 8.924 8.109C9.769 7.225 10.848 6.783 12.161 6.783C13.461 6.783 14.54 7.225 15.398 8.109C16.243 9.006 16.672 10.124 16.672 11.489C16.672 12.854 16.243 13.972 15.398 14.856C14.54 15.74 13.461 16.182 12.161 16.182ZM12.161 15.207C13.136 15.207 13.942 14.856 14.566 14.154C15.19 13.452 15.502 12.568 15.502 11.489C15.502 10.41 15.19 9.526 14.566 8.811C13.942 8.109 13.136 7.758 12.161 7.758C11.186 7.758 10.393 8.109 9.769 8.811C9.132 9.526 8.82 10.41 8.82 11.489C8.82 12.568 9.132 13.452 9.769 14.154C10.393 14.856 11.186 15.207 12.161 15.207Z",
    fill: "#657CCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterO);
export default __webpack_public_path__ + "static/media/letterO.ebc8567694f75a757dabeddfe78677ba.svg";
export { ForwardRef as ReactComponent };